import React, {Component} from 'react'

import Content from '../Content'
import Item from '../Item'
import Link from '../Link'
import List from '../Lists'
import Media from '../Media'
import Slider from '../Slider'


import Amenity from '../../models/Amenity'

class Amenities extends Component {

  render () {

    const {
      entry
    } = this.props

    let type = entry.locationCategory

    console.log('entry location', entry);



    if ( type == "live") {

      let slideshow = null;

      if(entry.amenitiesSlideshow.length){
        
          slideshow = (
              
                

                    <List modifiers={['locations','amenitiesGallery']}>
                    {/*<li className="List-item  List-item--heading">

                        <Content>

                          <h3>Ameneties Gallery</h3>

                        </Content>

                    </li>*/}
                      

                          <li className="List-item  List-item--content">
                            <Slider className="Slider--ratio">
                            { entry.amenitiesSlideshow.map( image => (
                            <Media id={image}  />
                             )) }
                            </Slider>
                          </li>

                       
                      

                    </List>

     


             )

      }

      return ([
        <div className="Template-section Template-section--narrow">

          <div className="Template-heading">
              <Content modifier={'alt'}>
                <h1>Amenities</h1>
              </Content>
          </div><div className="Template-content">

       {slideshow}
          <Content>
            <ul class="Amenities">
            <Amenity id={entry.amenities} render={
                (item) => (
                  <li>{item.title}</li>
                  )
            }/>
            </ul>
            </Content>
          </div>
        </div>]
      )
    } else {
      return null;
    }
  }
}

export default Amenities



// WEBPACK FOOTER //
// ./src/js/components/Amenities/Amenities.jsx